import KeyIcon from '@mui/icons-material/Key';
import SecretsList from './SecretsList';
import SecretsShow from './SecretsShow';
import SecretsCreate from './SecretsCreate';
import SecretsEdit from './SecretsEdit';

export default {
    list: SecretsList,
    show: SecretsShow,
    create: SecretsCreate,
    edit: SecretsEdit,
    icon: KeyIcon,
};
